import type { StateCreator } from 'zustand';
import type { AppStore } from './types';

export interface AppSliceState {
  ready: boolean;
  bootError: string | null;
  saveMode: 'idb' | 'localStorage' | 'session';
}

export interface AppSliceActions {
  setReady: (ready: boolean) => void;
  setBootError: (msg: string | null) => void;
  setSaveMode: (mode: AppSliceState['saveMode']) => void;
}

export type AppSlice = AppSliceState & AppSliceActions;

export const initialAppState: AppSliceState = {
  ready: false,
  bootError: null,
  saveMode: 'idb',
};

export const createAppSlice: StateCreator<AppStore, [], [], AppSlice> = (set) => ({
  ...initialAppState,
  setReady: (ready) => {
    set({ ready });
  },
  setBootError: (bootError) => {
    set({ bootError });
  },
  setSaveMode: (saveMode) => {
    set({ saveMode });
  },
});
